module.exports = __webpack_public_path__ + "static/media/highest-member-rated-health-plan_100@3x.b6313461.png";